import { CookiesStorage } from "../storage/index";
import { Logger } from "./logger";
import { LogLevel, LogLevels } from "./logger.models";

export class LoggerServiceSingleton {
    private static instance: LoggerServiceSingleton;
    private _logPrefix: string = "DEFAULT+PREFIX";
    private _cookiePrefix: string = "DEFAULT+PREFIX";
    private _loggers: Map<string, Logger>;
    private _logLevel: LogLevel = LogLevel.Debug;
    private _logEnabled: boolean = false;

    static get Instance() {
        // console.log("LoggerService.GetInstance");
        if (this.instance === null || this.instance === undefined) {
            // console.log("LoggerService.GetInstance. NO INSTANCE, CREATING");
            this.instance = new LoggerServiceSingleton();
            this.instance._loggers = new Map();
        } else {
            // console.log("LoggerService.GetInstance. HAS INSTANCE");
        }
        return this.instance;
    }

    public setLogPrefix(val: string, cookie_prefix: string): void {
        // console.log('Logger.setEnabled == ', clsName, val);
        this._logPrefix = val;
        this._cookiePrefix = cookie_prefix;
        CookiesStorage.setPrefix(cookie_prefix);
    }

    public createLogger(name: string, style?: string): Logger {
        //console.log('creating Logger', name);
        this._logLevel = LogLevel.Trace;
        this._logEnabled = true;
        if (CookiesStorage.get("logLevel")) {
            //console.log("%%%% has loglevel cookie");
            this._logLevel = LogLevels.FromString(CookiesStorage.get("logLevel"));
        };
        let logEnabled = CookiesStorage.get("logEnabled");
        if (typeof logEnabled === "string") {
            
            if (logEnabled.toLowerCase() === "true") {
                this._logEnabled = true;
            } else {
                this._logEnabled = false;
            }
        }else{
            
            this._logEnabled = logEnabled;
        }
        //console.log("LoggerService.createLogger", name, "logEnabled", this._logEnabled, "logLevel", this._logLevel, "style", style);
        let logger = new Logger(name, this._logEnabled, this._logLevel, style);
        logger.setLogPrefix(this._logPrefix);
        this._loggers.set(name, logger);
        return logger;
    }

    public setEnabled(val: boolean): void {
        //console.log("LOGGER SERVICE.setEnabled", val);
        this._logEnabled = val;
        CookiesStorage.set("logEnabled", val.toString(), {useRootDomain: true, path:'/', secure:true});
        this._loggers.forEach((logger, key, map) => {
            // console.log('logger', logger, 'key', key);
            logger.setEnabled(val);
        });
    }

    public setLevel(strLogLevel: string): void {
        try {
            //console.log("LOGGER SERVICE.setLevel", strLogLevel);
            // see if passed in string is a valid LogLevel
            CookiesStorage.set("logLevel", strLogLevel, {useRootDomain: true, path:'/', secure:true});
            this._logLevel = LogLevels.FromString(strLogLevel);
            // console.log('setLevel...FromString = ', strLogLevel, ' --  level=', logLevel);
            this._loggers.forEach((value, key, map) => {
                value.setLogLevel(LogLevels.FromString(strLogLevel));
            });
        } catch (e) {
            console.error(e.message);
        }
        // console.log('LOGGER SERVICE.setLevel', level);
    }
}
//console.log("LoggerServiceSingleton.Instance");
export let LoggerService = LoggerServiceSingleton.Instance;